module.exports = __webpack_public_path__ + "img/rot02.423cedb1.jpg";